module.exports = __webpack_public_path__ + "img/Virtual_Immersive.6157bd6e.png";